import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  sportsMyTicketsApi,
  transferTicketApi,
  championsApi,
} from 'src/app/shared/constants/api.constants';
import { ApprovalStatusEnum } from 'src/app/shared/enums/approval-status.enum';
import { MyTicketsStatusEnum } from 'src/app/shared/enums/my-tickets-status-enum';
import { TransferTicketsComponent } from '../../../../shared/components/transfer-tickets/transfer-tickets.component';
import { HelpersService, HttpBaseService, ToastService } from '@evento-ng/libs';
import { Toast } from 'src/app/shared/enums/toast';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IChampion } from 'src/app/shared/models/IChampion.model';
@Component({
  selector: 'app-sport-tickets',
  templateUrl: './sport-tickets.component.html',
  styleUrls: ['./sport-tickets.component.scss'],
})
export class SportTicketsComponent {
  @Input() filter: any;
  @Input() selectAll = false;
  invoices: any;
  filterForm: FormGroup;
  selectedInvoiceTickets: any[];
  page = 1;
  ApprovalStatusEnum = ApprovalStatusEnum;
  MyTicketsStatusEnum = MyTicketsStatusEnum;
  myTicketsStatus = 'UPCOMING';
  public hours: any;
  preventTransferAll = true;
  preventCancelAll = true;
  teamColor = '#3dbeb4';
  preventedIds = true;
  ticketsMeta: any;
  champions: IChampion;
  @Output() invoicesChanged = new EventEmitter<any>();

  constructor(
    private dataService: HttpBaseService,
    private spinner: NgxSpinnerService,
    public helpers: HelpersService,
    private modalService: NgbModal,
    public translate: TranslateService,
    private toast: ToastService,
    private formBuilder: FormBuilder
  ) {}
  ngOnChanges(changes: any) {
    console.log(changes);
    if (changes['filter']?.currentValue) {
      this.filter = changes['filter'].currentValue;
      this.getTickets();
    }
    if (
      (changes['selectAll']?.currentValue == true ||
        changes['selectAll']?.currentValue == false) &&
      changes['selectAll'].previousValue !== changes['selectAll'].currentValue
    ) {
      this.selectAll = changes['selectAll'].currentValue;
      this.toggleSelectAll();
    }
  }
  ngOnInit() {
    this.page = 1;

    this.getTickets();
    this.initform();
    this.getAllChampions();
  }

  toggleCheckbox(ticket: any) {
    ticket.isChecked = !ticket.isChecked;
    this.selectedInvoiceTickets = this.invoices?.filter(
      (ticket) => ticket.isChecked
    );
    this.handleSelectedTickets();
  }

  toggleSelectAll() {
    if (!this.selectAll) {
      this.invoices = this.invoices?.map((item) => {
        item.isChecked = false;
        return item;
      });
    } else {
      {
        this.invoices = this.invoices?.map((item) => {
          item.isChecked = true;
          return item;
        });
      }
    }
    this.selectedInvoiceTickets = this.invoices?.filter(
      (ticket) => ticket.isChecked
    );
    this.handleSelectedTickets();
  }

  getTickets(): void {
    this.spinner.show();
    const params: any = {
      page: this.page,
    };
    if (this.filter?.transferred == true || this.filter?.transferred == false) {
      params.transferred = this.filter?.transferred;
    }

    if (this.filter?.championId) {
      params.championId = this.filter?.championId;
    }

    this.dataService
      .get(`${sportsMyTicketsApi}`, { params })
      .subscribe((res) => {
        this.spinner.hide();
        this.invoices = res.data;
        this.invoicesChanged.emit(res);
        this.ticketsMeta = res.meta;
        this.selectedInvoiceTickets = [];
        this.invoices.forEach((item: any) => {
          this.hours = item.preventQRBefore;
        });
      });
  }

  onFilterChange() {
    this.getTickets();
  }

  private initform() {
    this.filterForm = this.formBuilder.group({
      ticketType: [''],
      championId: [''],
    });
  }
  getAllChampions() {
    this.spinner.show();
    this.dataService.get(`${championsApi}`).subscribe((res) => {
      this.champions = res.data;
      this.spinner.hide();
    });
  }

  transferTicket(ticketId: string) {
    let modalRef = this.modalService.open(TransferTicketsComponent, {
      centered: true,
    });
    modalRef.componentInstance.orderId = ticketId;
    modalRef.componentInstance.apiCall = 'ticket';
    modalRef.componentInstance.transfer.subscribe((receivedEntry: any) => {
      this.getTickets();
      this.selectAll = false;
      modalRef.dismiss();
    });
  }

  toggleExpand(ticket: any) {
    ticket.expanded = !ticket.expanded;
  }

  cancelTicket(ids) {
    this.spinner.show();
    this.dataService
      .patch(`${transferTicketApi}/cancel`, { ids: ids })
      .subscribe(
        (res) => {
          if (res.accepted != 0) {
            this.spinner.hide();
            this.toast.show(
              'Success',
              this.translate.instant('Sport.CancelTransferSuccess'),
              {
                classname: Toast.success,
              }
            );
          } else {
            this.spinner.hide();
            this.toast.show('Error', res.error.message, {
              classname: Toast.error,
            });
          }
          this.getTickets();
        },
        (Err) => {
          this.spinner.hide();
        }
      );
  }

  transferDisabledTicket(ticketId: string | number) {
    let modalRef = this.modalService.open(TransferTicketsComponent, {
      centered: true,
    });
    modalRef.componentInstance.orderId = ticketId;
    modalRef.componentInstance.apiCall = 'disabled';
    modalRef.componentInstance.transfer.subscribe((receivedEntry: any) => {
      this.getTickets();
      this.selectAll = false;
      modalRef.dismiss();
    });
  }

  transferTickets() {
    let modalRef = this.modalService.open(TransferTicketsComponent, {
      centered: true,
    });

    modalRef.componentInstance.selectedTickets = this.selectedInvoiceTickets;
    this.preventedIds
      ? (modalRef.componentInstance.apiCall = 'ticketNumber')
      : (modalRef.componentInstance.apiCall = 'ticketId');
    modalRef.componentInstance.transfer.subscribe((receivedEntry: any) => {
      this.getTickets();
      this.selectAll = false;
      modalRef.dismiss();
    });
  }

  cancelTransferTickets() {
    this.cancelTicket(
      this.selectedInvoiceTickets?.map((ticket) => ticket.transferOrderId)
    );
  }
  handleSelectedTickets() {
    const selectedTicketsIds = this.selectedInvoiceTickets?.map(
      (ticket) => ticket.id
    );
    this.preventedIds = selectedTicketsIds?.includes('$$$$');
    this.preventTransferAll = this.selectedInvoiceTickets?.some(
      (ticket) =>
        ticket.transferOrderStatus === 'UNDERTRANSFER' ||
        ticket.ticketSubKind === 'FULL_SEASON'
    );
    this.preventCancelAll = this.selectedInvoiceTickets?.some(
      (ticket) =>
        ticket.transferOrderStatus === 'TRANSFERRED' ||
        ticket.transferOrderStatus === null
    );
  }
  goToPage(n: number): void {
    this.page = n;
    this.spinner.show();
    this.getTickets();
  }

  onNext(): void {
    this.page++;
    this.spinner.show();
    this.getTickets();
  }

  onPrev(): void {
    this.page--;
    this.spinner.show();
    this.getTickets();
  }
}
